module.exports = __webpack_public_path__ + "img/title.76368eda.jpg";